import React, { useEffect, useState, createContext } from 'react'

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { useLocation } from 'react-router-dom';

import SingleSessions from "./SingleSessionsTable"
// import Packages from "./PackagesTable"
// import SwitchTabButtons from './SwitchTabButtons';

import { useContext } from "react";
import { UserContext } from "App";
const index = () => {

  const CurrentUser = useContext(UserContext)
  
  
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SingleSessions CurrentUser = {CurrentUser}/>
    </DashboardLayout>
  )
}

export default index